import {TextField} from '@hconnect/common/components'
import {CardBox} from '@hconnect/uikit/src/lib2'
import {Stack} from '@mui/material'
import {useFormContext} from 'react-hook-form'

import {ChecklistStepSection, YesNoField, YesNoWithCommentField} from '../../components'
import {HROC_CHECKLIST_FORM_WIDTH_IN_PX} from '../../consts'
import {useWidgetTranslation} from '../../hooks'
import type {KilnCheckSheetAdditionalCommentsSectionFormValues} from '../../types'
import {StepFormActionsContainer} from '../StepFormActionsContainer'

type Props = {
  readOnly?: boolean
}

export const AdditionalCommentsSectionFields = ({readOnly = false}: Props) => {
  const {control} = useFormContext<KilnCheckSheetAdditionalCommentsSectionFormValues>()
  const {t} = useWidgetTranslation()

  return (
    <CardBox width={{xs: '100%', md: HROC_CHECKLIST_FORM_WIDTH_IN_PX}}>
      <Stack spacing={2}>
        <ChecklistStepSection title={t('kilnCheckSheet.label.additionalComments')}>
          <YesNoField
            label={t('kilnCheckSheet.label.checkLinesForOilLeaksOrSpills')}
            name="checkLinesForOilLeaksOrSpills"
            control={control}
            readOnly={readOnly}
          />
          <TextField
            name="checkLinesForOilLeaksOrSpillsActionTaken"
            label={t('kilnCheckSheet.label.checkLinesForOilLeaksOrSpillsActionTaken')}
            optional
            control={control}
            readOnly={readOnly}
          />
          <YesNoWithCommentField
            label={t('kilnCheckSheet.label.jackhammerInServerRoom')}
            name="jackhammerInServerRoom"
            control={control}
            readOnly={readOnly}
          />
          <YesNoWithCommentField
            label={t('kilnCheckSheet.label.jackhammerInCabinetByClinkerBreaker')}
            name="jackhammerInCabinetByClinkerBreaker"
            control={control}
            readOnly={readOnly}
          />
        </ChecklistStepSection>
        <StepFormActionsContainer />
      </Stack>
    </CardBox>
  )
}
